import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import { useState, useCallback, useEffect } from 'react';

var useResizeObserver = function useResizeObserver(ref) {
  var _useState = useState({
      scrollWidth: 0,
      scrollHeight: 0,
      clientWidth: 0,
      clientHeight: 0,
      offsetWidth: 0,
      offsetHeight: 0
    }),
    _useState2 = _slicedToArray(_useState, 2),
    size = _useState2[0],
    setSize = _useState2[1];
  var triggerMeasurement = useCallback(function () {
    if (ref.current) setSize({
      scrollWidth: ref.current.scrollWidth,
      scrollHeight: ref.current.scrollHeight,
      clientWidth: ref.current.clientWidth,
      clientHeight: ref.current.clientHeight,
      offsetWidth: ref.current.offsetWidth,
      offsetHeight: ref.current.offsetHeight
    });
  }, [ref]);
  useEffect(function () {
    if (!ref.current) return;
    var resizeObserver = new ResizeObserver(triggerMeasurement);
    resizeObserver.observe(ref.current);
    return function () {
      return resizeObserver.disconnect();
    };
  }, [triggerMeasurement, ref]);
  return size;
};

export { useResizeObserver };
